import { createHistory } from './HistoryExtended';

const history = createHistory({ defaultBackPath: '/todo' });

export type { IHistory } from './HistoryExtended';
export { history };
